import {defaultKeywords} from "../keywords";

export const seoContentMapEs = {
    '/': {
        title: "Rodin - Generador de Modelos 3D con IA gratis a partir de imágenes | Hyper3D",
        description: "Crea impresionantes modelos 3D con IA en cuestión de segundos. Genera modelos 3D a partir de texto o imágenes fácilmente y revoluciona tu proceso creativo hoy mismo.",
        keywords: defaultKeywords,
        h1Text: "Rodin - Generador de Modelos 3D con IA gratis usando texto e imágenes",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revoluciona el modelado 3D con Rodin y ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/"
    },
    '/rodin': {
        title: "Rodin - Generador de Modelos 3D con IA gratis | Hyper3D",
        description: "Crea impresionantes modelos 3D con IA en cuestión de segundos. Genera modelos 3D a partir de texto o imágenes fácilmente y revoluciona tu proceso creativo hoy mismo.",
        keywords: defaultKeywords,
        h1Text: "Rodin - Generador de Modelos 3D con IA gratis usando texto e imágenes",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revoluciona el modelado 3D con Rodin y ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/"
    },
    '/rodin/page': {
        title: "Rodin - Generador de Modelos 3D con IA",
        description: "Crea impresionantes modelos 3D con IA en cuestión de segundos. Genera modelos 3D a partir de texto o imágenes fácilmente y revoluciona tu proceso creativo hoy mismo.",
        keywords: defaultKeywords,
        h1Text: "Rodin - Generador de Modelos 3D con IA gratis usando texto e imágenes",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revoluciona el modelado 3D con Rodin y ChatAvatar",
    },
    '/rodin/search': {
        title: "Modelos 3D | Hyper3D",
        description: "Listos para ver y descargar gratis en fbx, obj, glb y usd. Perfectos para juegos, VR/AR, producción de video e impresión 3D.",
        keywords: defaultKeywords,
        h1Text: "Rodin - Generador de Modelos 3D con IA gratis usando texto e imágenes",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revoluciona el modelado 3D con Rodin y ChatAvatar",
    },
    '/rodin/tab/story': {
        title: "Rodin - Colección de Historias de Usuario | Hyper3D",
        description: "Explora una amplia variedad de historias de usuario y descubre cómo Rodin está transformando el proceso creativo de artistas y diseñadores.",
        keywords: defaultKeywords,
        h1Text: "Rodin - Generador de Modelos 3D con IA gratis usando texto e imágenes",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revoluciona el modelado 3D con Rodin y ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/rodin/tab/story"
    },
    '/chatavatar': {
        title: "ChatAvatar - Generador de Activos Faciales 3D con IA | Hyper3D",
        description: "ChatAvatar de Hyper3D crea activos faciales 3D hiperrealistas, listos para producción, con texturas PBR a partir de texto o imágenes en minutos.",
        keywords: defaultKeywords,
        h1Text: "ChatAvatar - Generador de Activos Faciales 3D",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revoluciona el modelado 3D con Rodin y ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/chatavatar"
    },
    '/imageto3d': {
        title: "ChatAvatar - Generador de Activos Faciales 3D con IA | Hyper3D",
        description: "ChatAvatar de Deemos Hyper3D crea activos faciales 3D hiperrealistas, listos para producción, con texturas PBR a partir de texto o imágenes en minutos.",
        keywords: defaultKeywords,
        h1Text: "ChatAvatar - Generador de Activos Faciales 3D",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revoluciona el modelado 3D con Rodin y ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/chatavatar"
    },
    '/subscribe': {
        title: "Precios | Hyper3D",
        description: "Suscríbete a Hyper3D para acceder a funciones y contenidos exclusivos.",
        keywords: defaultKeywords + "Subscription, Hyper3D, Premium, Features",
        h1Text: "Suscripción - Hyper3D",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revoluciona el modelado 3D con Rodin y ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/subscribe"
    },
    '/api-dashboard': {
        title: "Panel de API | Hyper3D",
        description: "Administra tus claves de la API de Hyper3D y supervisa las estadísticas de uso.",
        keywords: defaultKeywords + "API, Dashboard, Hyper3D, API Keys, Usage",
        h1Text: "Panel de API",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revoluciona el modelado 3D con Rodin y ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/api-dashboard"
    },
    '/user/login': {
        title: "Iniciar Sesión | Hyper3D",
        description: "Accede a tu cuenta de Hyper3D. Gratis y fácil de usar. Pide y Hyper3D te ayudará con modelado, texturizado y más.",
        keywords: defaultKeywords + "Login, Hyper3D, User, Account",
        h1Text: "Iniciar Sesión",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revoluciona el modelado 3D con Rodin y ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/user/login"
    },
    '/signup': {
        title: "Crear Cuenta | Hyper3D",
        description: "Crea una nueva cuenta de Hyper3D. Gratis y fácil de usar. Pide y Hyper3D te ayudará con modelado, texturizado y más.",
        keywords: defaultKeywords + "Sign Up, Hyper3D, Register, Account",
        h1Text: "Crear Cuenta",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revoluciona el modelado 3D con Rodin y ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/signup"
    },
    '/legal/privacy': {
        title: "Política de Privacidad | Hyper3D",
        description: "Lee la política de privacidad de Hyper3D para entender cómo manejamos tus datos.",
        keywords: defaultKeywords + "Privacy Policy, Hyper3D, Data Protection, Privacy",
        h1Text: "Política de Privacidad",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revoluciona el modelado 3D con Rodin y ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/legal/privacy"
    },
    '/legal/terms': {
        title: "Términos del Servicio | Hyper3D",
        description: "Lee los términos y condiciones de Hyper3D. Estos términos regulan la creación con los servicios de Hyper3D.",
        keywords: defaultKeywords + "Terms of Service, Hyper3D, Terms, Conditions",
        h1Text: "Términos del Servicio",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revoluciona el modelado 3D con Rodin y ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/legal/terms"
    },
    '/product/faq': {
        title: "Preguntas Frecuentes | Hyper3D",
        description: "Encuentra respuestas a las preguntas más comunes sobre los productos y servicios de Hyper3D.",
        keywords: defaultKeywords + "FAQ, Hyper3D, Questions, Answers, Help",
        h1Text: "Preguntas Frecuentes",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revoluciona el modelado 3D con Rodin y ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/product/faq"
    },
    '/omnicraft': {
        title: "OmniCraft - Herramientas 3D | Hyper3D",
        description: "Omnicraft es una caja de herramientas de modelado 3D en línea y gratuita para artistas 3D, desarrolladores de videojuegos, diseñadores y más.",
        keywords: defaultKeywords + "HDRI Generator, image generator, image creator, omnicraft",
        h1Text: "Crea Tu Propio Mundo Virtual a partir de Imágenes, Texto e Imaginación",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revoluciona el modelado 3D con Rodin y ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/omnicraft/"
    },
    '/omnicraft/hdri': {
        title: "Generador de Panoramas HDRI - Construye tu Propio Mundo Virtual | Hyper3D",
        description: "Crea tu propio mundo virtual con nuestro generador de panoramas HDRI en segundos. A partir de imágenes, texto e imaginación.",
        keywords: defaultKeywords + "HDRI Generator, image generator, image creator, panorama generator, skybox generator",
        h1Text: "Crea Tu Propio Mundo Virtual a partir de Imágenes, Texto e Imaginación",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revoluciona el modelado 3D con Rodin y ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/omnicraft/hdri"
    },
    '/omnicraft/formatcon': {
        title: "Convertidor de Formatos 3D - Gratis y Totalmente Offline | Hyper3D",
        description: "Simplemente arrastra y suelta tu archivo de modelo 3D para convertirlo a cualquier formato popular como obj, fbx, gltf, glb y usd. Gratis y totalmente offline.",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "Convertidor de Modelos 3D Gratis, Seguro y Totalmente Offline",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revoluciona el modelado 3D con Rodin y ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/omnicraft/formatcon"
    },
    '/omnicraft/mesh': {
        title: "Esculpido de Mallas 3D - Gratis y Totalmente Offline | Hyper3D",
        description: "Herramienta de esculpido de mallas 3D que admite formatos populares como obj, fbx, 3ds, dxf, glb y usd. Gratis y totalmente offline.",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "Convertidor de Modelos 3D Gratis, Seguro y Totalmente Offline",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revoluciona el modelado 3D con Rodin y ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/omnicraft/mesh"
    },
    '/omnicraft/search': {
        title: "Rodin Search - Buscador de Modelos 3D | Hyper3D",
        description: "Buscador 3D que encuentra rápidamente modelos de Sketchfab, Daz3D y Rodin utilizando imágenes, texto o el propio modelo 3D.",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "Rodin Search - Buscador de Modelos 3D",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revoluciona el modelado 3D con Rodin y ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/omnicraft/search"
    },
    '/omnicraft/viewer': {
        title: "Visor de Modelos 3D - Gratis y Totalmente Offline | Hyper3D",
        description: "Visor de modelos 3D que admite cualquier formato popular, como obj, fbx, stl, gltf, 3ds, dxf, ply, glb y usd.",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "Visor de Modelos 3D Gratis, Seguro y Totalmente Offline",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revoluciona el modelado 3D con Rodin y ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/omnicraft/viewer"
    },
    '/omnicraft/texture': {
        title: "Generador de Texturas 3D - Texturas 3D a partir de Imágenes | Hyper3D",
        description: "Generador de texturas con IA que permite a cualquier persona dar vida a modelos, juegos, AR/VR y arte con texturas realistas a partir de imágenes.",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "Generador de Texturas 3D Gratis, Seguro y Totalmente Offline",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revoluciona el modelado 3D con Rodin y ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/omnicraft/texture"
    },
}